import { render, staticRenderFns } from "./AuthUserMenu.vue?vue&type=template&id=6ccc2a9c"
import script from "./AuthUserMenu.vue?vue&type=script&lang=js"
export * from "./AuthUserMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports